import React from 'react';
import { motion } from 'framer-motion';
import { Section } from './ui/Section';
import { Brain, MessageCircleHeart, ShieldCheck, Flame, Compass, HeartHandshake } from 'lucide-react';
const benefits = [{
  icon: Brain,
  title: 'Entender tus patrones invisibles',
  desc: 'Descubrí por qué repetís las mismas dinámicas tóxicas y cómo romper el ciclo de una vez.'
}, {
  icon: MessageCircleHeart,
  title: 'Comunicarte sin herir ni callarte',
  desc: 'Aprendé a decir lo que sentís sin atacar, y a escuchar sin ponerte a la defensiva.'
}, {
  icon: ShieldCheck,
  title: 'Pelear sin destruir el vínculo',
  desc: 'El conflicto es inevitable. El daño, no. Herramientas para discutir de forma sana y reparar rápido.'
}, {
  icon: Flame,
  title: 'Reavivar la intimidad emocional',
  desc: 'Ejercicios concretos para volver a sentirse vistos, valorados y deseados en el día a día.'
}, {
  icon: Compass,
  title: 'Construir un proyecto de vida juntos',
  desc: 'Alineen sus visiones sin perder su individualidad. Un "nosotros" fuerte y con propósito.'
}, {
  icon: HeartHandshake,
  title: 'Sanar heridas del pasado',
  desc: 'Técnicas para soltar resentimientos acumulados y empezar de nuevo desde la confianza.'
}];
export function BeneficiosSection() {
  return <Section background="secondary" data-id="element-129">
      <div className="text-center mb-16" data-id="element-130">
        <span className="text-accent font-bold tracking-widest uppercase text-sm mb-3 block" data-id="element-131">
          ¿Qué vas a aprender?
        </span>
        <h2 className="font-serif text-3xl md:text-4xl text-white mb-6" data-id="element-132">
          Todo lo que necesitás para transformar tu relación
        </h2>
        <p className="text-lg text-muted max-w-2xl mx-auto" data-id="element-133">
          Herramientas prácticas basadas en psicología y neurociencia,
          explicadas de forma simple y humana.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto" data-id="element-134">
        {benefits.map((benefit, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: index * 0.08
      }} className="bg-navy-700 border border-navy-border rounded-xl p-6 text-center" data-id="element-135">
            <div className="w-14 h-14 rounded-full bg-navy-900 border border-accent/30 shadow-[0_0_15px_rgba(224,122,240,0.15)] flex items-center justify-center text-accent mx-auto mb-4" data-id="element-136">
              <benefit.icon size={24} strokeWidth={1.5} data-id="element-137" />
            </div>
            <h3 className="text-lg font-serif font-bold text-accent mb-3" data-id="element-138">
              {benefit.title}
            </h3>
            <p className="text-muted text-sm leading-relaxed" data-id="element-139">{benefit.desc}</p>
          </motion.div>)}
      </div>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="mt-16 max-w-3xl mx-auto text-center" data-id="element-140">
        <div className="bg-navy-700 border border-accent/20 rounded-2xl p-8 relative overflow-hidden" data-id="element-141">
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-accent to-transparent opacity-40" data-id="element-142" />
          <p className="font-serif text-xl md:text-2xl text-white italic" data-id="element-143">
            "El amor consciente no es perfecto,{' '}
            <span className="text-accent" data-id="element-144">es intencional.</span>"
          </p>
        </div>
      </motion.div>
    </Section>;
}